import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Fetch all articles
export const fetchArticles = createAsyncThunk(
  "blog/fetchArticles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}articles`
      );
      return response?.data;
    } catch (error) {
      // console.error("fetchArticles API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Fetch article by ID
export const fetchArticleById = createAsyncThunk(
  "blog/fetchArticleById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}articles/${id}`
      );
      // console.log("response single article",response)
      // console.log("response!!!",response)
      return response?.data; // Single article object
    } catch (error) {
      // console.error("fetchArticleById API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// Fetch article by ID
export const fetchArticleBySlug = createAsyncThunk(
  "blog/fetchArticleBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}articles/slug/${slug}`
      );
      // console.log("response single article",response)
      // console.log("response!!!",response)
      return response?.data; // Single article object
    } catch (error) {
      // console.error("fetchArticleById API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
const blogSlice = createSlice({
  name: "blog",
  initialState: {
  articles: [],
  selectedArticle: null,
  status: "idle",
  error: null,
  next_page_url: null,
  prev_page_url: null,
  suggestions: null,
  currentPage: 1,
  itemsPerPage: 10,
  lastPage: 1,
  },
  reducers: {
    clearSelectedArticle: (state) => {
      state.selectedArticle = null;
    },
        setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
      state.currentPage = 1; // Reset to page 1 when changing items per page
    },
  },
  extraReducers: (builder) => {
    // Fetch all articles
    builder.addCase(fetchArticles.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(fetchArticles.fulfilled, (state, action) => {
      state.status = "succeeded";
      //articles 
      state.articles = action.payload?.data || [];
      //one Article
      state.selectedArticle = action.payload.data.article;
      //pagination
      state.currentPage = action.payload?.current_page || 1;
      state.itemsPerPage = action.payload?.per_page || 10;
      state.lastPage = action.payload?.last_page || 1;
      state.totalItems = action.payload?.total || 0;
      state.next_page_url = action.payload?.next_page_url || null;
      state.prev_page_url = action.payload?.prev_page_url || null;
    });

    builder.addCase(fetchArticles.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || "Erreur inconnue";
    });

    // Fetch article by ID
    builder.addCase(fetchArticleBySlug.pending, (state) => {
      state.status = "loading";
    });
    builder.addCase(fetchArticleBySlug.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.selectedArticle = action.payload?.article;
      state.suggestions = action.payload?.suggestions;
    });
    builder.addCase(fetchArticleBySlug.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload || "Erreur inconnue";
    });
  },
});

export const { clearSelectedArticle, setItemsPerPage } = blogSlice.actions;
export const selectAllArticles = (state) => state.blog.articles;
export const SelectedArticle = (state) => state.blog.selectedArticle;
export const selectSuggestions = (state) => state.blog.suggestions;
export default blogSlice.reducer;
